import httpService from "./httpService";

export interface ActualPerformanceItem {
  date: string;
  endingValue: number;
  twr: number | null;
  changeInNavAdjusted: number;
  changeInNavInputs: number;
  twrExclusions: number;
  ibkrTwr: number;
}

export interface ActualPerformanceResponse {
  items: ActualPerformanceItem[];
}

class ActualPerformanceService {
  async getActualPerformance(
    signal?: AbortSignal
  ): Promise<ActualPerformanceResponse> {
    const response = await httpService.get<ActualPerformanceResponse>(
      "/v3/investor/actual-performance",
      { signal }
    );
    return response.data;
  }

  async getActualPerformanceForUser(
    userId: string,
    signal?: AbortSignal
  ): Promise<ActualPerformanceResponse> {
    const response = await httpService.get<ActualPerformanceResponse>(
      `/v3/investors/${userId}/actual-performance`,
      { signal, requestScope: "actor" }
    );
    return response.data;
  }
}

const actualPerformanceService = new ActualPerformanceService();
export default actualPerformanceService;
